import { io } from "socket.io-client";

let URL = "";
let url_servidor = `${window.location.protocol}//${window.location.host}`;

if (url_servidor == `${window.location.protocol}//suasfacil.host`) {
    URL = `${window.location.protocol}//suasfacil.servidor.host:3002`;
} else {
    URL = "https://server.suasfacil.com.br";
}

const socket = io(URL, { secure: true });

socket.onAny((event, ...args) => {
    console.log(event, args);
});

export default socket;
